export default __webpack_public_path__ + "static/media/icon-Marketplace-Solutions.5d1ad9a6.svg";